// コンシェル追従ボタン
const btnCon = document.getElementById('btnCon');
const SCROLL_THRESHOLD = 90;
let isClosed = false;          // ← 閉じたかどうかのフラグを追加
let listenerAdded = false;

// 表示/非表示を更新する関数（閉じていたら何もしない）
function updateButton() {
  if (isClosed) return;        // 閉じていたら強制的に非表示のまま

  if (window.scrollY > SCROLL_THRESHOLD) {
    btnCon.classList.add('is-visible');
  } else {
    btnCon.classList.remove('is-visible');
  }
}

// クリックで閉じる処理
function addCloseListener() {
  if (listenerAdded) return;
  const span = btnCon.querySelector('span');  // 閉じる用のspan要素
  if (!span) return;

  span.addEventListener('click', () => {
    btnCon.classList.remove('is-visible');
    isClosed = true;                       // ← ここでフラグを立てる

    // オプション：アニメーション後に完全に非表示にしたい場合
    // setTimeout(() => btnCon.style.display = 'none', 400);
  });

  listenerAdded = true;
}

// スクロールイベント
window.addEventListener('scroll', updateButton, { passive: true });

// ページ読み込み時
window.addEventListener('load', () => {
  updateButton();      // 初期状態セット
  addCloseListener();  // リスナー追加
});

